<template>
    <div style="height: 100vh; width: 100vw">
        <Scene ref="scene" @tokenmove="onTokenMove" @onCharacterChanged="onCharacterChanged"></Scene>
        <UserPanel></UserPanel>
        <DiceRollerWindow />
        <CharacterLibrary />
        <SceneLibrary />
    </div>
</template>

<script>
import Vue from 'vue';
import VueKonva from 'vue-konva';

import LivePlayDirector from '@/core/live/LivePlayDirector';
import Scene from '@/components/scene/Scene.vue';

import DiceRollerWindow from '@/components/scene/diceroller/DiceRollerWindow.vue';
import CharacterLibrary from '@/components/library/characters/CharacterLibrary.vue';
import SceneLibrary from '@/components/library/scenes/SceneLibrary.vue';
import UserPanel from '@/components/userPanel/UserPanel.vue';

Vue.use(VueKonva);

export default {
    components: {
        DiceRollerWindow: DiceRollerWindow,
        CharacterLibrary: CharacterLibrary,
        SceneLibrary: SceneLibrary,
        Scene: Scene,
        UserPanel: UserPanel,
    },
    props: {
        sessionId: {
            type: String,
            default: '',
        },
        sceneId: {
            type: String,
            default: '',
        },
    },
    computed: {
        gridSpace() {
            return this.$refs.scene.renderContext.gridSpace;
        },
    },
    provide: function() {
        return {
            director: this.director,
        };
    },
    watch: {
        sceneId: {
            handler() {
                this.loadScene({
                    sessionId: this.sessionId,
                    sceneId: this.sceneId,
                });
            },
            deep: true,
        },
    },
    beforeRouteEnter(to, from, next) {
        var fromName;
        if (from.name) fromName = from.name;
        else fromName = from.path.replace(/\//g, '-');
        Vue.$gtag.event(`from-${fromName}`, {
            event_category: 'start-campaign',
        });
        next();
    },
    beforeCreate() {
        this.director = new LivePlayDirector(this.$store);
        this.director.init();
    },
    created() {
        this.loadScene({ sessionId: this.sessionId, sceneId: this.sceneId });
    },
    mounted() {
        // Need to wait until child components exist before attaching listeners
        this.$nextTick(() => {
            this.fitSceneToWindow();
            window.addEventListener('resize', this.fitSceneToWindow);
        });
    },
    async beforeDestroy() {
        this.$store.dispatch('gamestate/clear');
        window.removeEventListener('resize', this.fitSceneToWindow);
        await this.director.disconnect();
    },
    methods: {
        async loadScene({ sessionId, sceneId }) {
            console.log(`Scene Loaded: ${sessionId}/${sceneId}`);
            if (sceneId == 'debug') {
                const liveDebug = await import('./debug/LivePlayDebug');
                await liveDebug.loadDebugScene({ vm: this, sessionId, sceneId });
                return;
            }
            console.warn(`Unknown scene: ${sessionId}/${sceneId}...`);
        },
        fitSceneToWindow() {
            this.$refs.scene.fitToContainer();
        },
        onTokenMove({ entity, pos }) {
            this.director.moveToken(entity.id, pos);
        },
        onCharacterChanged({ characterId, patch }) {
            this.director.updateToken(characterId, patch);
        },
    },
};
</script>

<style>
body {
    margin: 0;
}
</style>
